// extracted by mini-css-extract-plugin
export var audioLabel = "promoted-content-styleB-module--audioLabel--47027";
export var audioPlayer = "promoted-content-styleB-module--audioPlayer--cb38d";
export var bottomFloatImage = "promoted-content-styleB-module--bottomFloatImage--0a1a1";
export var centerFloatImage = "promoted-content-styleB-module--centerFloatImage--0b82b";
export var container = "promoted-content-styleB-module--container--24414";
export var contentBox = "promoted-content-styleB-module--contentBox--47df9";
export var credentials = "promoted-content-styleB-module--credentials--f143c";
export var cta = "promoted-content-styleB-module--cta--bf11b";
export var ctaContainer = "promoted-content-styleB-module--ctaContainer--f185d";
export var headline = "promoted-content-styleB-module--headline--8c5ba";
export var image = "promoted-content-styleB-module--image--9d908";
export var innerContent = "promoted-content-styleB-module--innerContent--c1d03";
export var modal = "promoted-content-styleB-module--modal--73e17";
export var modalPreviewPlayIcon = "promoted-content-styleB-module--modalPreviewPlayIcon--a54f0";
export var name = "promoted-content-styleB-module--name--9d434";
export var paragraph = "promoted-content-styleB-module--paragraph--b99b4";
export var playArrow = "promoted-content-styleB-module--playArrow--395b7";
export var playerWrapper = "promoted-content-styleB-module--playerWrapper--5a353";
export var primaryimage = "promoted-content-styleB-module--primaryimage--086a1";
export var reactPlayer = "promoted-content-styleB-module--reactPlayer--a0259";
export var secondaryRight = "promoted-content-styleB-module--secondaryRight--3010b";
export var secondaryimage = "promoted-content-styleB-module--secondaryimage--70b16";
export var topFloatImage = "promoted-content-styleB-module--topFloatImage--3617a";
export var videoWrapper = "promoted-content-styleB-module--videoWrapper--dfb60";
export var wrapper = "promoted-content-styleB-module--wrapper--672ad";